import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ZipModel } from './model/zip.model';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ZipSearcherService {
    constructor(
        protected httpService: HttpClient
    ) { }

    public getZipCode(zipCode: string): Observable<ZipModel | { erro: boolean }> {
        return this.httpService.get<ZipModel>('https://viacep.com.br/ws/' + zipCode + '/json');
    }
}
